module.exports = __webpack_public_path__ + "static/media/profile-pic.960e902b.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/profile-pic.png
// module id = 701
// module chunks = 0